import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const buttonFromLocation = location => {
  if (location.pathname.indexOf('questions') > -1) {
    return (
      <div className="item">
        <Link
          to="/questions/new"
          className="ui right floated right labeled icon button"
        >
          <i className="add icon" />
          Ajouter une question
        </Link>
      </div>
    );
  }

  if (location.pathname.indexOf('advices') > -1) {
    return (
      <div className="item">
        <Link
          to="/advices/new"
          className="ui right floated right labeled icon button"
        >
          <i className="add icon" />
          Ajouter un conseil
        </Link>
      </div>
    );
  }

  return null;
};

const FunnelHeader = ({ name, location, onSave }) => (
  <div className="ui top attached menu">
    <div className="item">
      <a href="/funnels" className="ui labeled icon button">
        <i className="sidebar icon" />
        Retour à la liste
      </a>
    </div>
    <div className="header item">
      <h3>{name}</h3>
    </div>
    <div className="right menu">
      {buttonFromLocation(location)}
      <div className="item">
        <button className="ui right floated primary button" onClick={onSave}>
          Enregistrer
        </button>
      </div>
    </div>
  </div>
);

FunnelHeader.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default FunnelHeader;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/FunnelHeader.js